
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MsInput',
  inheritAttrs: false
})
